import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import styled from 'styled-components';
import { Box, FormControl, ListItemText } from '@mui/material';

const StyledAutoComplete = styled(Autocomplete)<{ error?: boolean; disabled?: boolean }>`
	& .MuiInputBase-root {
		border: 1.5px solid ${(props) => (props?.error ? 'red' : '#e9e9e9')} !important;
		border-radius: 4px;
		width: 100%;
		&:hover {
			border: 1.5px solid ${(props) => (props?.error ? 'red' : '#e9e9e9')} !important;
		}
		min-height: 36px;
		padding-left: 10px;
		padding-top: 4px;
		padding-bottom: 4px;
	}
`;

const StyledLabel = styled(Box)`
	color: var(--color-font-grey);
	font-size: 14px;
	font-weight: 600;
	line-height: 15.6px;
	span {
		color: #f26184;
		margin-left: 4px;
	}
`;

interface Option {
	id: string;
	value: string;
	disable?: boolean;
}

interface Props {
	selectedOption: Option | Option[] | null;

	options: Option[];
	onChange: (value: Option | null) => void;
	label?: string;
	required?: boolean;
	disabled?: boolean;
	placeholder?: string;
	style?: any;
	renderOption?: any;
	multiple?: boolean;
	error?: string;
}

const AutoComplete: React.FC<Props> = ({
	selectedOption,
	options,
	onChange,
	label = '',
	required = false,
	disabled = false,
	placeholder = 'Type Something...',
	style = { width: '100%', height: 'auto' },
	renderOption,
	multiple = false,
	error = '',
}) => {
	return (
		<StyledAutoComplete
			id="single-value-autocomplete"
			options={options}
			value={selectedOption}
			onChange={(event: any, newValue: any) => {
				onChange(newValue);
			}}
			renderOption={(props, item) => {
				if (renderOption) {
					return renderOption(props, item);
				}
				return (
					//@ts-ignore
					<li {...props} key={item?.id}>
						{/* @ts-ignore */}
						<ListItemText>{item?.value}</ListItemText>
					</li>
				);
			}}
			getOptionLabel={(option: any) => option?.value}
			renderInput={(params: TextFieldProps) => (
				<div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
					<StyledLabel style={disabled ? { color: 'var(--gray-g-400, #ACACAC)' } : {}}>
						{label}
						{required ? <span>*</span> : null}
					</StyledLabel>
					<FormControl sx={style}>
						<TextField
							{...params}
							variant="standard"
							InputProps={{ ...params.InputProps, disableUnderline: true }}
							placeholder={placeholder}
						/>
					</FormControl>
				</div>
			)}
			multiple={multiple}
			error={!!error}
		/>
	);
};

export default AutoComplete;
